import { IActionResult } from '../types/IActionResult';
import { Request } from './Request';

export interface IUpdateConnectionsOAuthParams {
  ids: string[];        // Data source ids
  keychainEntryId?: string;  // Id of the user keychain that should be embedded in data connections,
                             // or undefined to remove the existing embedded keychain
}

export class UpdateConnectionsOAuthRequest extends Request<IUpdateConnectionsOAuthParams, IActionResult> {
  constructor(params: IUpdateConnectionsOAuthParams) {
    super('updateConnectionsOAuth', params);
  }
}
